import React from 'react';
import './receiptKindChip.css';

// Small brand-styled tag naming what a payment/deposit row actually WAS —
// 'Booking Request', 'Booking Payment', 'Invoice settlement', 'Wallet top-up',
// 'Card verification' (receipt_kind from the payments/deposits listings).
// Renders nothing when the API row doesn't carry a kind (older rows / older
// backend) so it is safe to drop into any list unconditionally.
//
// P1 — A CARD PAYMENT IS NOT A TOP-UP. This map is the single place the portal
// names a money row, so the two families must never share a style:
//   * BOOKING money — booking payment / edit payment / auto-charge / adjustment
//                     payment. Belongs to a BOOKING. Styled 'booking'.
//   * WALLET money  — top-ups only. Styled 'topup'.
// Anything unrecognised falls through to the neutral 'other' style rather than
// borrowing either look, so a future backend kind can never be mislabelled as a
// top-up by accident.
const KIND_CLASS = {
    'booking request': 'rkchip--request',
    'booking payment': 'rkchip--booking',
    // Direct-rail kinds — each is a payment FOR A BOOKING, never wallet money.
    'booking edit payment': 'rkchip--booking',
    'booking auto-charge': 'rkchip--booking',
    'adjustment payment': 'rkchip--booking',
    'invoice settlement': 'rkchip--invoice',
    'wallet top-up': 'rkchip--topup',
    'card verification': 'rkchip--verify',
};

export default function ReceiptKindChip({ kind }) {
    if (!kind) return null;
    const cls = KIND_CLASS[String(kind).toLowerCase()] || 'rkchip--other';
    return <span className={`rkchip ${cls}`}>{kind}</span>;
}
